// Colour assignment for per-student chart series.
//
// The brief said "random colours". This uses a FIXED palette instead, and
// assigns from it deterministically, for two reasons:
//
//  1. Random hues collide. Two students can land on near-identical colours and
//     become impossible to tell apart — and there is no way to fix it except
//     reloading and hoping.
//  2. Random hues are not colourblind-safe. Roughly 1 in 12 men cannot
//     separate a random red from a random green.
//
// The palette is Okabe–Ito, published specifically for colour-vision
// deficiency, minus its pale yellow (unreadable as a thin line on white).
//
// The colour follows the STUDENT, not their position in the list: it is keyed
// off the student id, so a student keeps the same line colour when filters
// change or another student is added. Ordering the palette by rank would
// repaint everyone whenever the set changed.

const SERIES_PALETTE = [
  "#0072B2", // blue
  "#D55E00", // vermillion
  "#009E73", // bluish green
  "#CC79A7", // reddish purple
  "#E69F00", // orange
  "#56B4E9", // sky blue
  "#7A4E9F", // violet
  "#8C6D31", // brown
];

// Stable small hash so the same id always maps to the same slot.
const hashId = (id) => {
  const s = String(id);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
};

// Assigns a colour per id, preferring the hash slot but stepping to the next
// free one on collision — so two students never share a colour while there are
// still unused ones. Beyond the palette size colours do repeat; the chart warns
// when that happens rather than pretending otherwise.
export const assignSeriesColors = (ids = []) => {
  const taken = new Set();
  const out = {};
  ids.forEach((id) => {
    const start = hashId(id) % SERIES_PALETTE.length;
    let slot = start;
    for (let step = 0; step < SERIES_PALETTE.length; step++) {
      const candidate = (start + step) % SERIES_PALETTE.length;
      if (!taken.has(candidate)) { slot = candidate; break; }
    }
    taken.add(slot);
    out[id] = SERIES_PALETTE[slot];
  });
  return out;
};

export const SERIES_PALETTE_SIZE = SERIES_PALETTE.length;
export default SERIES_PALETTE;
